import { render, staticRenderFns } from "./Werbung.vue?vue&type=template&id=f8a05066&scoped=true"
import script from "./Werbung.vue?vue&type=script&lang=js"
export * from "./Werbung.vue?vue&type=script&lang=js"
import style0 from "./Werbung.vue?vue&type=style&index=0&id=f8a05066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a05066",
  null
  
)

export default component.exports